module.exports = __webpack_public_path__ + "img/tours_1.04dd3e33.jpg";